import React, { useEffect, useState } from 'react'
import { getProfitLoss } from '../../../Utility/Api'

const ProfitLossReport = () => {

  const [company, setCompany] = useState(JSON.parse(sessionStorage.getItem('SUB-COMPANY'))?.title)
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const todayStr = today.toISOString().split('T')[0];
  const yesterdayStr = yesterday.toISOString().split('T')[0];
  const [ledgerData, setLedgerData] = useState([])
  const [fromDate, setFromDate] = useState(yesterdayStr); // default today
  const [toDate, setToDate] = useState(todayStr);

  useEffect(() => {
    GetPRofitLossData(yesterdayStr, todayStr);
  }, [])

  const GetPRofitLossData = async (filterFromDate = '', filterToDate = '') => {
    try {
      const params = {};
      if (filterFromDate) params.start_date = filterFromDate;
      if (filterToDate) params.end_date = filterToDate;

      const res = await getProfitLoss(params);
      setLedgerData(res.data.grouped_data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    GetPRofitLossData(fromDate, toDate);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
        {/* {page == 1 && ( */}
        <>
          {/* <NaviGate /> */}
          {/* <h6 className="mt-3 text-uppercase">Daily Sales Reports</h6> */}

          <form
            onSubmit={handleFilter}
            className="card p-4 shadow-sm">
            <div className="row g-3 justify-content-end align-items-center">
              <h5 className="text-uppercase mb-0">{company} Profit Loss Report</h5>

              {/* <div className="col-md-2 ">
                   <div className="d-flex column-gap-2 ">
                     <button
                       className="btn btn-primary px-2 py-1 rounded-1 font-weight-2"
                       style={{ fontSize: "13px", width: "max-content" }}
                       onClick={() => handleDateFilter("week")}
                     >
                       Last Week
                     </button>
                     <button
                       className="btn btn-primary px-2 py-1 rounded-1 font-weight-2"
                       style={{ fontSize: "13px", width: "max-content" }}
                    //    onClick={() => handleDateFilter("month")}
                     >
                       Last Month
                     </button>
                   </div>
                 </div> */}
              <div className="col-md-2">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    id="fromDate"
                    value={fromDate}
                    max={toDate || new Date().toISOString().split('T')[0]}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                  <label htmlFor="fromDate">From Date</label>
                </div>
              </div>

              {/* To Date  */}
              <div className="col-md-2">
                <div className="form-floating">
                  <input
                    type="date"
                    className="form-control"
                    id="toDate"
                    value={toDate}
                    min={fromDate}
                    max={new Date().toISOString().split('T')[0]}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <label htmlFor="toDate">To Date</label>
                </div>
              </div>
              <div className="col-md-1">
                <button type="submit" className="btn btn-success px-3 py-3">
                  Filter
                </button>
              </div>
            </div>

            <div className="table-responsive text-center my-2 w-100 position-relative">
              <table className="table table-striped table-sm table-bordered">
                <thead className="table-dark">
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Profit/Loss</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let totalDebit = 0;
                    let totalCredit = 0;
                    let totalProfitLoss = 0;

                    // Temporarily hide Project Revenue and Service Revenue (uncomment below to restore)
                    // const filteredLedgerData = ledgerData;
                    const filteredLedgerData = ledgerData.filter(
                      item => item.remarks !== "Project Revenue" && item.remarks !== "Service Revenue"
                    );

                    const rows = filteredLedgerData.map((item, index) => {
                      let debit = '';
                      let credit = '';
                      let profitLoss = '';

                      // Conditional formatting based on type (Expenses are Debit, Revenues are Credit)
                      if (["3", "4", "6", "6.1", "6.2", "6.3"].includes(item.type)) {
                        debit = parseFloat(item.total_amount || 0).toFixed(2);
                        totalDebit += parseFloat(item.total_amount);
                      } else if (["5", "9", "10"].includes(item.type)) {
                        credit = parseFloat(item.total_amount || 0).toFixed(2);
                        totalCredit += parseFloat(item.total_amount);
                      } 
                      // else if (item.type === "3" || item.type === "10") {
                      //   credit = parseFloat(item.total_amount || 0).toFixed(2);
                      //   profitLoss = parseFloat(item.profitloss_total || 0).toFixed(2);
                      //   totalCredit += parseFloat(item.total_amount);
                      //   totalProfitLoss += parseFloat(item.profitloss_total);
                      // }

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.remarks}</td>
                          <td>{debit}</td>
                          <td>{credit}</td>
                          <td>{profitLoss}</td>
                        </tr>
                      );
                    });

                    const netProfit = totalCredit - totalDebit;
                    const isNetLoss = netProfit < 0;

                    // Summary and net rows 
                    rows.push(
                      <tr key="total" className="fw-bold" style={{ background: '#f8f9fa' }}>
                        <td colSpan="2">Total</td>
                        <td>{totalDebit.toFixed(2)}</td>
                        <td>{totalCredit.toFixed(2)}</td>
                        <td>{totalProfitLoss.toFixed(2)}</td>
                      </tr>,
                      <tr key="net" className="fw-bold ">
                        <td colSpan="4" className={isNetLoss ? 'text-white bg-danger' : 'bg-success text-white'}>
                          Net {isNetLoss ? 'Loss' : 'Profit'}
                        </td>
                        <td className={isNetLoss ? 'text-white bg-danger' : 'bg-success text-white'}>
                          {isNetLoss
                            ? `- ${Math.abs(netProfit).toFixed(2)}`
                            : `+ ${netProfit.toFixed(2)}`}
                        </td>
                      </tr>

                    );

                    return rows;
                  })()}
                </tbody>

              </table>
            </div>
          </form>
        </>
      </div>
    </div>
  );
}

export default ProfitLossReport
